var map = {
	"./account.svg": "lNpt",
	"./agreement.svg": "coBr",
	"./analysis.svg": "/tUJ",
	"./bill.svg": "hOaM",
	"./category.svg": "3HFE",
	"./clientManage.svg": "SCM8",
	"./code.svg": "IX5Q",
	"./config.svg": "e/UX",
	"./exit-fullscreen.svg": "G+/G",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./faq.svg": "i+/B",
	"./fullscreen.svg": "WIff",
	"./home.svg": "U9Ws",
	"./international.svg": "SBEl",
	"./language.svg": "+Dip",
	"./logisticsDelivery.svg": "+LR/",
	"./marketing.svg": "mkJ9",
	"./member.svg": "/LrJ",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./online.svg": "lWBX",
	"./operation.svg": "Dh6m",
	"./order.svg": "gYtG",
	"./page.svg": "zrC5",
	"./password.svg": "QjmH",
	"./peoples.svg": "TgHK",
	"./pic.svg": "OSsC",
	"./place.svg": "82yd",
	"./processed.svg": "l3VP",
	"./product.svg": "UHi4",
	"./report.svg": "2nwU",
	"./rmb.svg": "1bsR",
	"./schedule.svg": "qh1b",
	"./seller.svg": "8S16",
	"./sta.svg": "+MY1",
	"./system.svg": "Jax1",
	"./tax.svg": "eisL",
	"./test.svg": "fjDP",
	"./total-open.svg": "e2qL",
	"./total.svg": "3yBj",
	"./transferManag.svg": "+nhW",
	"./unlink.svg": "30Aw",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 52